import { EnumAccountGroup } from './Generated';
import { SelectOption } from '@synqo/frontend-component-library';

export const minimalAccountGroupOptions: SelectOption<EnumAccountGroup>[] = [
    { name: 'inland', label: 'Inland', value: EnumAccountGroup.Inland },
    { name: 'eec', label: 'EU', value: EnumAccountGroup.EEC },
    { name: 'abroad', label: 'Ausland', value: EnumAccountGroup.Abroad },
    { name: 'enterprise', label: 'Konzern', value: EnumAccountGroup.Enterprise },
];

export const allAccountGroupOptions: SelectOption<EnumAccountGroup>[] = [
    ...minimalAccountGroupOptions,
    { name: 'tax_free', label: 'Steuerfrei', value: EnumAccountGroup.TaxFree },
    { name: 'reverse_charge', label: 'Reverse Charge', value: EnumAccountGroup.ReverseCharge },
];
